<template>
  <div>
    <div class="header">
      <div class="dhl">
        <div class="dhl1">
          <router-link to="/">
            <a href="#a1">
              <img :src="fileServerUrl + 'assets/sold/soldlogo.png'" />
            </a>
          </router-link>
        </div>
        <div class="dhl2">
          <div class="dropdown">
            <a href="http://www.huiyuexpo.com/#/"
              ><span class="menu">{{ $t("organizer") }}</span></a
            >
          </div>
          <div class="dropdown">
            <router-link to="/">
              <a href="#a1"
                ><span
                  class="menu"
                  :class="{ 'menu-active': menuIndex == 1 }"
                  >{{ $t("home") }}</span
                ></a
              >
            </router-link>
          </div>

          <div class="dropdown">
            <span
              class="menu"
              :class="{ 'menu-active': menuIndex == 2 }"
              style="cursor: pointer"
              >{{ $t("meeting") }}</span
            >

            <div class="dropdown-content2">
              <router-link
                to="/meeting"
                class="menu"
                :class="{ 'menu-active': menuIndex == 3 }"
                ><p>{{ $t("meeting") }}</p></router-link
              >
              <!-- <router-link
                to="/aggenda"
                class="menu"
                :class="{ 'menu-active': menuIndex == 3 }"
                ><p>{{ $t("agenda") }}</p></router-link
              > -->
            </div>
          </div>

          <div class="dropdown">
            <span
              class="menu"
              :class="{ 'menu-active': menuIndex == 3 }"
              style="cursor: pointer"
              >{{ $t("Sponsorship_exhibitors") }}</span
            >

            <div class="dropdown-content1">
              <router-link
                to="/whysponsor"
                class="menu"
                :class="{ 'menu-active': menuIndex == 3 }"
                ><p>{{ $t("why_sponsor") }}</p></router-link
              >
              <router-link
                to="/exibitions"
                class="menu"
                :class="{ 'menu-active': menuIndex == 3 }"
                ><p>{{ $t("Sponsorship_exhibitors") }}</p></router-link
              >
            </div>
          </div>

          <!--                <div class="dropdown">
                    <router-link to="/awards">
                        <span class="menu" :class="{'menu-active':menuIndex==4}" style="cursor: pointer">奖项</span>
                    </router-link>
                </div>-->

          <div class="iconEn">
            <!-- <router-link to="/Enhomeview">
                        <i class="iconfont icon-diqiu3" style="margin-right:5px;color:#ffba27;font-size: 1em;font-weight: bold"></i>
                        <span  class="menu" :class="{'menu-active':menuIndex==6}">EN</span>
                    </router-link> -->
            <span
              @click="changeLang"
              class="menu"
              :class="{ 'menu-active': menuIndex == 6 }"
              ><i
                class="iconfont icon-diqiu3"
                style="
                  margin-right: 5px;
                  color: #ffba27;
                  font-size: 1em;
                  font-weight: bold;
                "
              ></i
              ></span
            >
          </div>

          <!-- <div class="dropdown joinnow">
            <div
              class="menu"
              :class="{ 'menu-active': menuIndex == 5 }"
              style="cursor: pointer"
            >
              {{ $t("enroll") }}
            </div>

            <div class="dropdown-content">
              <router-link
                to="/hyticket"
                class="menu"
                :class="{ 'menu-active': menuIndex == 5 }"
                ><p>{{ $t("conference_pass") }}</p></router-link
              >
              <router-link
                to="/freeticket"
                class="menu"
                :class="{ 'menu-active': menuIndex == 5 }"
                ><p>{{ $t("free_tickets") }}</p></router-link
              >
            </div>
          </div> -->

        </div>
      </div>
    </div>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
export default {
  props: ["menuIndex"],
  created() {},
  data() {
    return {
      fileServerUrl: fileServerUrl,
      flag: true,
    };
  },
  methods: {
    changeLang() {
      if (this.flag == true) {
        this.flag = !this.flag;
        this.$i18n.locale = "en";
      } else {
        this.flag = !this.flag;
        this.$i18n.locale = "zh";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// @import url('@/style/mobile/myHeader.scss');

div {
  font-family: PuHuiTi; //使用字体
}

.header {
  background-color: #1b1f2b;
  width: 100%;
  height: 40px;
  position: fixed;
  z-index: 999;
  top: 0px;
  margin-bottom: 20px;

  //border-bottom: 2px solid #85d11f;
  //border: 1px solid red;
}

.dhl {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  //background-color: #1b1c2a;
}

.dhl1 {
  height: 50%;
  margin-left: 10%;
  float: left;
  display: flex;
  align-items: center;
  //border:.1px solid red;
  //border:1px solid red;
}

.dhl1 img {
  width: 55px;
  height: 8px;
}
.dhl2 {
  display: flex;
  //justify-content: space-around;
  margin-left: 20%;
  align-items: center;
  width: 62%;
  height: 45%;
  //float: left;
  //border: .1px solid red;
  font-size: 0.1rem;
}

.dhl2 span:hover {
  color: #ffcc02;
}

.menu {
  color: white;
  cursor: pointer;
}

.menu-active {
  color: #ffcc02;
}

.dropdown {
  position: relative;
  margin-left: 6%;
  display: inline-block;
  //border: 1px solid rebeccapurple;
}

.dropdown-content {
  display: none;

  position: absolute;

  background-color: #1b1f2b;

  min-width: 30px;

  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

  padding: 12px 16px;

  margin-top: 85px;

  margin-left: -2px;

  font-size: 0.1rem;
}

.dropdown:hover .dropdown-content {
  display: block;
}
p:hover {
  color: #ffcc02;
}
p {
  color: #fff;
}
.dropdown-content1 {
  display: none;

  position: absolute;

  background-color: #1b1f2b;

  min-width: 40px;

  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

  padding: 12px 16px;

  margin-left: -15px;

  font-size: 0.1rem;
}
.dropdown:hover .dropdown-content1 {
  display: block;
}

.dropdown-content2 {
  display: none;

  position: absolute;

  background-color: #1b1f2b;

  min-width: 20px;

  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

  padding: 10px 15px;

  margin-left: -15px;

  font-size: 0.1rem;
}
.dropdown:hover .dropdown-content2 {
  display: block;
}

.joinnow {
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffba27;
  border-radius: 2px;
}

.iconEn {
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 6%;
  //font-weight: bold;
}

@media screen and (max-width: 767px) {
  .dhl {
    margin-top: 10px;
  }
}
</style>
